module.exports = __webpack_public_path__ + "static/media/4x6no2.8c212fd6.jpg";